import { AnyAction } from 'redux';

import * as constants from 'redux/constants/auth.constants';
import { ILoginFormData } from 'views/LoginView/types';
import { IRegisterFormData } from 'views/RegisterView/types';
import { IChangePassword } from 'views/public/ChangePasswordView/types';

export const onLogin = (formData: ILoginFormData, pathname?: string): AnyAction => ({
  type: constants.AUTH_ON_LOGIN_REQUESTED,
  formData,
  pathname,
});

export const onLoginPublic = (formData: ILoginFormData, pathname?: string): AnyAction => ({
  type: constants.AUTH_ON_LOGIN_PUBLIC_REQUESTED,
  formData,
  pathname,
});

export const onLogout = (): AnyAction => ({
  type: constants.AUTH_ON_LOGOUT_REQUESTED,
});

export const onLogoutPublic = (): AnyAction => ({
  type: constants.AUTH_ON_LOGOUT_PUBLIC_REQUESTED,
});

export const onRegisterPublic = (formData: IRegisterFormData): AnyAction => ({
  type: constants.AUTH_ON_REGISTER_PUBLIC_REQUESTED,
  formData,
});

export const onResetPassword = (email: string): AnyAction => ({
  type: constants.AUTH_ON_RESET_PASSWORD_REQUESTED,
  payload: { email },
});

export const onChangePassword = (formData: IChangePassword): AnyAction => ({
  type: constants.AUTH_ON_CHANGE_PASSWORD_REQUESTED,
  formData,
});
